export default __webpack_public_path__ + "static/media/Brochure.9460b705.pdf";